import { render, staticRenderFns } from "./document-indicator.vue?vue&type=template&id=a71913c8&scoped=true&"
import script from "./document-indicator.vue?vue&type=script&lang=ts&"
export * from "./document-indicator.vue?vue&type=script&lang=ts&"
import style0 from "./document-indicator.vue?vue&type=style&index=0&id=a71913c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71913c8",
  null
  
)

export default component.exports